import { render } from "./P003.vue?vue&type=template&id=31e1bb62&scoped=true"
import script from "./P003.vue?vue&type=script&lang=js"
export * from "./P003.vue?vue&type=script&lang=js"

import "./P003.vue?vue&type=style&index=0&id=31e1bb62&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31e1bb62"]])

export default __exports__